import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_FZS_910 } from "@/lib/programs/fezSidialiMarrakech910";

export default function FezSidialiMarrakech910Page() {
  return <ProgramTemplate program={PROGRAM_FZS_910} variant="fzs" showJourneyChronology />;
}
